import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import WorksSection from './components/WorksSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePageJP() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ExpertiseSection />
      <WorksSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
}